export default __webpack_public_path__ + "static/media/lp-lock.86250dc4.png";